import { CustomFontAwesomeIconProps } from './types'

import { faEye } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Show = (props: CustomFontAwesomeIconProps) => <FontAwesomeIcon {...props} icon={faEye} />

export default Show
